import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  AreaManagementUsageTableViewModel,
  AreaReturnSbuUsageTableViewModel,
} from '@core/api';
import { AreaManagementService } from '@core/services/area-management/area-management.service';
import { MtxGridColumn, MtxGridModule } from '@ng-matero/extensions/grid';
import { FieldType } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  IAddButtonConfig,
  ITableConfig,
  ITableFilterConfig,
  ITableGridConfig,
  ITablePagingConfig,
  ITableSelectConfig,
} from '@shared/components/table-base/table-base.types';

@Component({
  selector: 'app-usage-selection',
  imports: [CommonModule, MtxGridModule, FormsModule, TranslateModule],
  template: `
    <div style="margin-bottom: 40px;">
      <h2>{{ 'area_return.label__usage_selection' | translate }}</h2>
      <mtx-grid
        [columnResizable]="true"
        [columns]="props.columns"
        [data]="props.data$ | async"
        [length]="this.totalCount"
        [loading]="loadingData"
        [rowStriped]="true"
        [noResultText]="'grid.no_results' | translate"
        [rowStriped]="true"
        [rowHover]="false"
        [pageSizeOptions]="[5, 10, 25, 50, 100]"
        [cellSelectable]="false"
        [rowHover]="true"
        [pageSize]="config.grid.paging.pageSize"
        [pageIndex]="config.grid.paging.pageIndex"
        [showPaginator]="config.grid.paging.showPaginator"
        [columnHideable]="true"
        [columnMenuButtonText]="'grid.columns_shown' | translate"
        [columnHideableChecked]="'show' | translate"
        columnMenuButtonClass="col-button"
        [showSidebar]="true"
        [showToolbar]="true"
        [columnSortable]="true"
        [showColumnMenuButton]="true"
        columnMenuButtonType="flat"
        [columnPinnable]="false"
        (rowClick)="props.isVb ? onVbRowClick($event) : onRowClick($event)">
      </mtx-grid>
    </div>
  `,
  styles: [
    `
      .mtx-grid {
        max-height: 80vh;
      }
      ::ng-deep .mat-mdc-row {
        cursor: pointer;
      }
    `,
  ],
})
export class UsageSelectionComponent extends FieldType implements OnInit {
  readonly areaManagementService = inject(AreaManagementService);

  config: ITableConfig = <ITableConfig>{
    title: '',
    translatePath: '',
    addButton: <IAddButtonConfig>{
      disabled: true,
    },
    grid: <ITableGridConfig>{
      showToolbar: true,
      columnResizable: true,
      paging: <ITablePagingConfig>{
        pageIndex: 0,
        pageSize: 10,
        showPaginator: true,
      },
      filter: <ITableFilterConfig>{
        filterVisible: false,
        sortOnFront: false,
        filterOptions: {},
      },
      select: <ITableSelectConfig>{
        rowSelectable: true,
        multiSelectable: true,
      },
    },
  };

  totalCount: number;

  columns: MtxGridColumn[];

  loadingData = false;

  constructor(private cd: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    this.areaManagementService.loadingDataSubject$.subscribe({
      next: isLoading => {
        this.loadingData = isLoading;
        this.cd.markForCheck();
      },
    });

    if (this.props.data$) {
      this.props.data$.subscribe(data => {
        this.totalCount = data.length;
      });
    }
  }

  onRowClick(row: AreaManagementUsageTableViewModel): void {
    this.areaManagementService.addRow(row);
  }

  onVbRowClick(row: AreaReturnSbuUsageTableViewModel): void {
    this.areaManagementService.addRowVb(row);
  }
}
